<template>
  <div class="a4">
    <div style="padding: 203px 0;">
      <div style="background-color: #203A7B; color: #ffffff; font-family: Noto Sans KR; font-weight: 700; font-size: 46px; text-align: center; vertical-align: middle; height: 159px; padding: 10px 15px;">
        「{{header.year}}년 {{header.half}}」중대시민재해 대상 시설<br>안전관리 의무사항 이행 자체점검 결과
      </div>
    </div>

    <div style="padding:235.5px 0; ">
      <p style="font-family: Noto Sans KR; font-weight: 700; font-size: 46px; text-align: center; vertical-align: middle; color: #000000;">
        {{ new Date(`${header.year}-${header.month}`).format('yyyy. MM.') }}
      </p>
    </div>

    <div style="padding:126.5px 0; ">
      <p style="font-family: Noto Sans KR;
font-weight: 700;
font-size: 54px;
text-align: center;
vertical-align: middle;
color: #000000;
">사   천   시</p>
      <p style="font-family: Noto Sans KR;
font-weight: 700;
font-size: 40px;
text-align: center;
vertical-align: middle;
color: #000000;
">{{ value.소관부서 }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
